import { useSyncExternalStore } from 'react';
import type { FeedbackKind } from './api';

/** The sheet's open state, one for the app: the entry rows open it, FeedbackHost shows it. */
let isOpen = false;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
export const openFeedbackSheet = () => { isOpen = true; emit(); };
export const closeFeedbackSheet = () => { isOpen = false; emit(); };
export function useFeedbackSheetOpen(): boolean {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => isOpen);
}

/** The "Waiting to send" sheet, opened from the entry rows' "N waiting" chip. */
let queueOpen = false;
export const openFeedbackQueue = () => { queueOpen = true; emit(); };
export const closeFeedbackQueue = () => { queueOpen = false; emit(); };
export function useFeedbackQueueOpen(): boolean {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => queueOpen);
}

/** What the person typed, kept while the app is open when they close the sheet without sending ("closing keeps the draft"). */
export interface Draft { id: string; kind: FeedbackKind; message: string; includePage: boolean; replyOk: boolean }
let draft: Draft | null = null;
export const getDraft = () => draft;
export const saveDraft = (d: Draft) => { draft = d; };
export const clearDraft = () => { draft = null; };

/** Back to nothing open and no draft: when the person signs out or another signs in, what one typed must never reach the next. */
export function resetFeedbackState(): void {
  isOpen = false;
  queueOpen = false;
  draft = null;
  emit();
}
